var exports = {
  "iE": "x936d19a0--22f868--wrapper",
  "JW": "x936d19a0--22f868--svg",
  "rE": "x936d19a0--22f868--base-circle",
  "Zd": "x936d19a0--22f868--fill-circle",
  "hJ": "x936d19a0--22f868--counter",
  "TA": "x936d19a0--22f868--max-count",
};

module.exports = exports;
